'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Back';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Switch from 'Components/Forms/Elements/Switch';
import Loader from 'Pure/Loader';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import { num, formatNum } from 'Shared/utilities';
import { action } from 'Shared/Routes';
const {
  moment
} = window;
const cards = [{
  title: 'CA Meeting',
  field: 'ca',
  suffix: '€'
}, {
  title: 'CA Meeting hors service',
  field: 'ca_without_services',
  suffix: '€'
}, {
  title: 'Panier moyen Meeting',
  field: 'average',
  suffix: '€'
}, {
  title: 'Panier moyen Meeting hors service',
  field: 'average_without_services',
  suffix: '€'
}, {
  title: 'Nombre de transactions Meeting',
  field: 'transaction_count'
}, {
  title: 'Nombre de demi-journée Meeting',
  field: 'count_half_day'
}, {
  title: 'Nombre de journée Meeting',
  field: 'count_day'
}, {
  title: 'Fenêtre de réservation Meeting',
  field: 'booking_window',
  suffix: 'j'
}];
function getDefaultState() {
  const state = {
    start_date: '',
    end_date: '',
    global_stats: true,
    super_admin: window.location.pathname.startsWith('/super-admin-indicateurs'),
    status_messages: {}
  };
  if (state.super_admin) {
    state.start_date = moment().startOf('month').subtract(6, 'months').format('YYYY-MM-DD');
  }
  return state;
}
export default class MeetingIndicatorPage extends Component {
  state = getDefaultState.bind(this)();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchStats({});
  }
  handleFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    if (e !== null)
      // did mount
      {
        component.fetchStats({
          filters: {
            [name]: value
          }
        });
      }
  };
  fetchStat = async ({
    name,
    filters = {},
    ...other_params
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const params = {};
    ['start_date', 'end_date', 'super_admin', 'global_stats'].forEach(function (field) {
      params[field] = typeof filters[field] === 'undefined' ? state[field] : filters[field];
    });
    const response = await ajaxRequest(action(name), {
      data: {
        ...params,
        ...other_params
      }
    });
    return response;
  };
  fetchStats = async ({
    filters = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    const actions = [{
      name: 'getCA'
    }, {
      name: 'getCAWithoutServices'
    }, {
      name: 'getCartAverage'
    }, {
      name: 'getCartAverageWithoutServices'
    }, {
      name: 'getTransactionCount'
    }, {
      name: 'getBookingWindow'
    }, {
      name: 'getTransactionCountBySeminarType'
    }].map(data => ({
      ...data,
      filters,
      type: 'b_seminar'
    }));
    try {
      const requests = actions.map(params => component.fetchStat(params));
      var results = await Promise.all(requests);
    } catch (e) {
      return component.setState(e);
    }
    const update = {
      loading: false
    };
    results.forEach(function (response, i) {
      Object.assign(update, response);
    });
    component.setState(update);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const stat_loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    const stats = cards.map(function ({
      title,
      field,
      suffix,
      format
    }) {
      return /*#__PURE__*/React.createElement("div", {
        className: "c-stats__item",
        key: field
      }, /*#__PURE__*/React.createElement("h3", {
        className: "c-stats__item-title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "c-stats__item-result"
      }, formatNum(state[field], format || '0,0[.]00'), suffix), stat_loader);
    });
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Indicateurs Meeting"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['start_date'] || "",
      className: "cutom-date-picker",
      name: "start_date",
      label: "Date de d\xE9but",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['end_date'] || "",
      className: "cutom-date-picker",
      name: "end_date",
      label: "Date de fin",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleFilterChange,
      value: state.global_stats,
      name: "global_stats",
      label: "Afficher les stats globales",
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-margin-bottom-25"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-stats"
    }, stats))));
    return output;
  }
}
